"use client"

import Link from "next/link"
import { useState, type ComponentProps, type MouseEvent } from "react"
import { Button } from "@/components/ui/button"
import { reachGoal } from "@/lib/marketing/metrika"

export type MetrikaGoal = "calc_used" | "sample_download" | "upload_cta" | "pay_click"

function track(goal: MetrikaGoal, event: MouseEvent) {
  if (event.defaultPrevented) return
  reachGoal(goal)
}

export function TrackedLink({
  goal,
  onClick,
  ...props
}: ComponentProps<typeof Link> & { goal: MetrikaGoal }) {
  return (
    <Link
      {...props}
      data-metrika={goal}
      onClick={(event) => {
        onClick?.(event)
        track(goal, event)
      }}
    />
  )
}

export function TrackedAnchor({
  goal,
  onClick,
  ...props
}: ComponentProps<"a"> & { goal: MetrikaGoal }) {
  return (
    <a
      {...props}
      data-metrika={goal}
      onClick={(event) => {
        onClick?.(event)
        track(goal, event)
      }}
    />
  )
}

export function CopySampleButton({ text }: { text: string }) {
  const [state, setState] = useState<"idle" | "done" | "error">("idle")

  async function onClick() {
    try {
      await navigator.clipboard.writeText(text)
      reachGoal("sample_download")
      setState("done")
    } catch {
      setState("error")
    }
  }

  const label = state === "done" ? "Скопировано" : "Скопировать текст"

  return (
    <div className="space-y-2">
      <Button
        type="button"
        variant="outline"
        className="w-full"
        data-metrika="sample_download"
        onClick={() => {
          void onClick()
        }}
      >
        {label}
      </Button>
      {state === "error" ? (
        <p className="text-sm text-destructive" role="alert">
          Не удалось скопировать. Скачайте файл.
        </p>
      ) : null}
    </div>
  )
}
